import { afterNextRender, Component, ElementRef, inject, viewChild } from '@angular/core';
import { ToastrService } from './toastr.service';
import { ActiveToast } from './toast.model';

/**
 * Rendert de actieve toasts. Wordt door {@link ToastrService} één keer aangemaakt en aan
 * `document.body` gehangen; de DOM-structuur/classes (`#toast-container`, `.toast`,
 * `.toast-message`, `.toast-close-button`) komen overeen met wat de bestaande toast-CSS verwacht.
 *
 * De container heeft `popover="manual"`, zodat hij (net als CDK's overlays sinds v21, via
 * `usePopover`) in de browser's native top layer rendert — gegarandeerd boven alle andere
 * content, ongeacht z-index. `showPopover()` wordt éénmalig aangeroepen na de eerste render.
 */
@Component({
	selector: 'cl-toast-container',
	standalone: true,
	templateUrl: './toast-container.component.html',
	styleUrls: ['./toast-container.component.scss'],
})
export class ToastContainerComponent {
	protected readonly toastr = inject(ToastrService);

	private readonly container = viewChild.required<ElementRef<HTMLElement>>('container');

	constructor() {
		afterNextRender(() => {
			const el = this.container().nativeElement;
			if (typeof el.showPopover === 'function') el.showPopover();
		});
	}

	protected toastClass(toast: ActiveToast): string {
		return `toast ${toast.cssClass}${toast.leaving ? ' toast-leaving' : ''}`.trim();
	}
}
